import { alpha } from "@mui/material/styles";
import { brand, gray, orange } from "../themePrimitives";

export const feedbackCustomisations = {
  MuiTypography: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: (theme.vars || theme).palette.text.primary,
      }),
    },
    variants: [
      {
        props: { variant: "h1" },
        style: ({ theme }) => ({ color: theme.palette.secondary.main }),
      },
      {
        props: { variant: "h2" },
        style: ({ theme }) => ({ color: theme.palette.secondary.main }),
      },
      {
        props: { variant: "h3" },
        style: ({ theme }) => ({ color: theme.palette.secondary.main }),
      },
      {
        props: { variant: "h4" },
        style: ({ theme }) => ({ color: theme.palette.secondary.main }),
      },
    ],
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        backgroundColor: orange[100],
        color: (theme.vars || theme).palette.text.primary,
        border: `1px solid ${alpha(orange[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: orange[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(orange[900], 0.5)}`,
          border: `1px solid ${alpha(orange[800], 0.5)}`,
        }),
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          border: "1px solid",
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.secondary.main,
        fontWeight: 700,
        "&+.MuiDialogContent-root": {
          paddingTop: theme.spacing(2),
        },
      }),
    },
  },
  MuiLinearProgress: {
    defaultProps: {
      color: "primary",
    },
    styleOverrides: {
      root: () => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        "& .MuiLinearProgress-bar": {
          backgroundColor: brand[500],
        },
      }),
    },
  },
  MuiRating: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        color: theme.palette.rating.default,
        "& .MuiSvgIcon-root": {
          color: theme.palette.rating.default,
        },
      }),
    },
  },
};
